var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[(_vm.origin === _vm.currentEnterpriseOrigin)?_vm._t("default"):_vm._t("fallback")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }